import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import Modal from "../../components/Modal";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import BlockRightImage from "../../components/BlockRightImage";
import Block2Columns from "../../components/Block2ColumnsText";
import Block3Columns from "../../components/Block3Columns";
import BlockLeftImage from "../../components/BlockLeftImage";
import Notification from "../../components/Notification";
import Breadcumbs from "../../components/Breadcumbs";
import { NavLink } from "react-router-dom";

import ConectUs from "../../components/ConectUs";
import Accordion from "../../components/Accordion";

function Modalidadenlinea() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            <BlockImageCabecera
              src={item.field_portada}
              title={
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_texto_portada,
                    }}
                  />
                </>
              }
            ></BlockImageCabecera>
            <div className="lightbluebg">
              <Breadcumbs
                content={
                  <>
               
          
                    <NavLink to="/estudiar-en-linea">Estudiar en línea</NavLink>
                  </>
                }
              ></Breadcumbs>
              <BlockLeftImage
                src={item.field_imagen1}
                content={
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque1,
                      }}
                    />
                    <Modal
                      title="Conoce nuestro modelo educativo"
                      content={
                        <>
                          <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/nfPmXX9vgsY?si=Cr9qYgPc11MtzbKN"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin"
                            allowfullscreen
                          ></iframe>
                        </>
                      }
                    ></Modal>
                  </>
                }
              ></BlockLeftImage>
            </div>

            <BlockBackgroundImage
              src={item.field_imagen2}
              content={
                <div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque2,
                    }}
                  />
                  <Modal
                    title="Revisa nuestro sistema de evaluación"
                    content={
                      <>
                        <iframe
                          width="560"
                          height="315"
                          src="https://www.youtube.com/embed/U7SCIV7qHGM?si=uAABUCb3xrNETYhD"
                          title="YouTube video player"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerpolicy="strict-origin-when-cross-origin"
                          allowfullscreen
                        ></iframe>
                      </>
                    }
                  ></Modal>
                </div>
              }
            ></BlockBackgroundImage>

            <div className="lightbluebg padding bloque-perfil-enlinea">
              <Block2Columns
                col1={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque3,
                    }}
                  />
                }
                col2={
                  <>
                    <Block3Columns
                      col1={
                        <>
                          <center>
                            <div className="icon20">
                              <img src={item.field_imagen4}></img>
                            </div>

                            <div
                              dangerouslySetInnerHTML={{
                                __html: item.field_bloque4,
                              }}
                            />
                          </center>
                        </>
                      }
                      col2={
                        <>
                          <center>
                            <div className="icon20">
                              <img src={item.field_imagen5}></img>
                            </div>

                            <div
                              dangerouslySetInnerHTML={{
                                __html: item.field_bloque5,
                              }}
                            />
                          </center>
                        </>
                      }
                      col3={
                        <>
                          <center>
                            <div className="icon20">
                              <img src={item.field_imagen6}></img>
                            </div>

                            <div
                              dangerouslySetInnerHTML={{
                                __html: item.field_bloque6,
                              }}
                            />
                          </center>
                        </>
                      }
                    ></Block3Columns>
                    <div className="margin">
                      <Block3Columns
                        col1={
                          <>
                            <center>
                              <div className="icon20">
                                <img src={item.field_imagen7}></img>
                              </div>

                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.field_bloque7,
                                }}
                              />
                            </center>
                          </>
                        }
                        col2={
                          <>
                            <center>
                              <div className="icon20">
                                <img src={item.field_imagen8}></img>
                              </div>

                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.field_bloque8,
                                }}
                              />
                            </center>
                          </>
                        }
                        col3={
                          <>
                            <center>
                              <div className="icon20">
                                <img src={item.field_imagen9}></img>
                              </div>

                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.field_bloque9,
                                }}
                              />
                            </center>
                          </>
                        }
                      ></Block3Columns>
                    </div>
                    <div className="margin">
                      <Block3Columns
                        col1={
                          <>
                            <center>
                              <div className="icon20">
                                <img src={item.field_imagen10}></img>
                              </div>

                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.field_bloque10,
                                }}
                              />
                            </center>
                          </>
                        }
                        col2={
                          <>
                            <center>
                              <div className="icon20">
                                <img src={item.field_imagen11}></img>
                              </div>

                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.field_bloque11,
                                }}
                              />
                            </center>
                          </>
                        }
                        col3={
                          <>
                            <center>
                              <div className="icon20">
                                <img src={item.field_imagen12}></img>
                              </div>

                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.field_bloque12,
                                }}
                              />
                            </center>
                          </>
                        }
                      ></Block3Columns>
                    </div>

                    <div className="margin">
                      <Block3Columns
                        col1={
                          <>
                            <center>
                              <div className="icon20">
                                <img src={item.field_imagen13}></img>
                              </div>

                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.field_bloque13,
                                }}
                              />
                            </center>
                          </>
                        }
                        col2={
                          <>
                            <center>
                              <div className="icon20">
                                <img src={item.field_imagen14}></img>
                              </div>

                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.field_bloque14,
                                }}
                              />
                            </center>
                          </>
                        }
                        col3={
                          <>
                            <center>
                              <div className="icon20">
                                <img src={item.field_imagen15}></img>
                              </div>

                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.field_bloque15,
                                }}
                              />
                            </center>
                          </>
                        }
                      ></Block3Columns>
                    </div>
                  </>
                }
              ></Block2Columns>
            </div>
            <div className="padding bluebg">
              <center>
                <div className="width700">
                  <div
                    className="layout8"
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque16,
                    }}
                  />
                </div>
                <Block3Columns
                  col1={
                    <>
                      <div className="icon200">
                        <img src={item.field_imagen17}></img>
                      </div>
                      <div
                        className="layout8"
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque17,
                        }}
                      />

                      <Modal
                        title="Conoce cómo ingresar al EVA"
                        content={
                          <>
                            <iframe
                              width="560"
                              height="315"
                              src="https://www.youtube.com/embed/s1hImFISwvQ?si=f5S3WTsm-lTeJ-8_"
                              title="YouTube video player"
                              frameborder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                              referrerpolicy="strict-origin-when-cross-origin"
                              allowfullscreen
                            ></iframe>
                          </>
                        }
                      ></Modal>
                    </>
                  }
                  col2={
                    <>
                      <div className="icon200 margin">
                        <img src={item.field_imagen18}></img>
                      </div>
                      <div
                        className="layout8"
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque18,
                        }}
                      />
                    </>
                  }
                  col3={
                    <>
                      <div className="icon200">
                        <img src={item.field_imagen19}></img>
                      </div>
                      <div
                        className="layout8"
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque19,
                        }}
                      />
                    </>
                  }
                ></Block3Columns>{" "}
              </center>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  const DataDisplay2 = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            <div className="padding graybg">
              <center>
                <div
                  className="width700"
                  dangerouslySetInnerHTML={{
                    __html: item.field_texto_portada,
                  }}
                />
              </center>
              <Block3Columns
                col1={
                  <>
                    <center>
                      <div className="icon200">
                        <img src={item.field_imagen1}></img>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque1,
                        }}
                      />
                    </center>
                  </>
                }
                col2={
                  <>
                    <center>
                      <div className="icon200 margin">
                        <img src={item.field_imagen2}></img>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque2,
                        }}
                      />
                    </center>
                  </>
                }
                col3={
                  <>
                    <center>
                      <div className="icon200">
                        <img src={item.field_imagen3}></img>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque3,
                        }}
                      />
                    </center>
                  </>
                }
              ></Block3Columns>
            </div>

            <div className="padding lightbluebg">
              <div className="layout8">
                <div
                  className="width500"
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque4,
                  }}
                />

                <Accordion
                  title="Prácticas preprofesionales"
                  content={
                    <>
                      {" "}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque5,
                        }}
                      />
                    </>
                  }
                ></Accordion>
                <Accordion
                  title="Proyectos de vinculación"
                  content={
                    <>
                      {" "}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque6,
                        }}
                      />
                    </>
                  }
                ></Accordion>
                <Accordion
                  title="Movilidad virtual"
                  content={
                    <>
                      {" "}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque7,
                        }}
                      />
                    </>
                  }
                ></Accordion>

                    <Accordion
                  title="Unidad de integración curricular"
                  content={
                    <>
                      {" "}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque12,
                        }}
                      />
                    </>
                  }
                ></Accordion>

              </div>
            </div>
            <BlockRightImage
              src={item.field_imagen8}
              content={
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque8,
                  }}
                />
              }
            ></BlockRightImage>

            <BlockLeftImage
              src={item.field_imagen9}
              content={
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque9,
                  }}
                />
              }
            ></BlockLeftImage>

            <BlockBackgroundImage
              src={item.field_imagen10}
              content={
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque10,
                  }}
                />
              }
            ></BlockBackgroundImage>
            <div className="bluebg padding">
              <Notification
                content={
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque11,
                      }}
                    />
                  </>
                }
              ></Notification>
            </div>
          </div>
        ))}
      </div>
    </>
  );
  return (
    <>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/oferta/servicio-enlinea.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>

      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/oferta/servicio-enlinea2.json">
        {(data) => <DataDisplay2 data={data} />}
      </DataFetcherTemplate>
      <ConectUs
        facebook="https://www.facebook.com/utpltec/"
        instagram="https://www.instagram.com/utpltec/"
        tiktok="https://www.tiktok.com/@utpltec"
        x="https://twitter.com/utpl?lang=es"
        youtube="https://www.youtube.com/user/utpl/"
        linkedin="https://www.linkedin.com/company/utpl-tec/"
      ></ConectUs>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default Modalidadenlinea;
